import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DepartmentService } from '../../customerservice/services/department.service';

@Component({
    selector: 'app-email-whitelist',
    templateUrl: "../templates/template1/views/email-whitelist.component.html",
    styleUrls: ["../templates/template1/themes/default/CSS/email-whitelist.component.less"]
})

export class EmailWhitelistComponent implements OnInit {
    uuid: string;
    emailId: string;
    isSuccess: boolean = false;
    validationMessage: string;
    isFailure: boolean = false;
    departmentId: number;
    constructor(
        private aroute: ActivatedRoute,
        private _departmentService: DepartmentService) {
    }
    
    ngOnInit() {
        this.aroute.queryParams.subscribe(params => {            
            this.emailId = params['emailid'];
            this.uuid = params['uuid'];
            this.departmentId = params['id'];
            this.isFailure = false;
            this.isSuccess = false;
            this.validationMessage = '';
            if (this.emailId && this.departmentId) {
                if (this.uuid) {
                    this.verifyDepartmentEmail();
                } else {
                    this.isFailure = true;
                    this.validationMessage = 'Invalid verification link, please reach out development team.';
                }
            }
        });
    }
    
    /**
     * verify department email based on department id, email id and verification code
     */
    verifyDepartmentEmail() {
        this._departmentService.whitelistDepartmentEmail(this.emailId, this.uuid, this.departmentId).subscribe((res: any) => {
            if (res.success === true) {
                this.isSuccess = true;
                this.validationMessage = 'Email whitelisting acknowledgment is successful.';
            } else {
                this.isSuccess = true;
                this.validationMessage = 'Looks like email whitelisting acknowledgment is already completed.';
            }
        } , error => {
            this.isFailure = true;
            this.validationMessage = 'Error while whitelisting acknowledgment, please reach out development team.';
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/components/email-whitelist.component.ts